import React, { ReactNode } from 'react';
import { Link as ExternalLink } from '@stockx/ui';
import { Link as InternalLink, PageSwitcherTypes } from '@app/router';

import { MenuItem } from '@app/shell/SiteHeader/shared/components/menu/shared/types/menu';

import {
  DropdownLinkGridContainer,
  ItemWrapper,
} from './DropdownLinkGrid.styles';

type ContainerProps = {
  children: ReactNode;
  className: string;
  left?: string;
};

/**
 *
 * @constructor
 */
export const Container = ({
  children,
  className,
  left = '0px',
}: ContainerProps) => (
  <DropdownLinkGridContainer className={className} left={left}>
    {children}
  </DropdownLinkGridContainer>
);

type ItemProps = {
  item: MenuItem;
  handleOnClick: (MenuItem) => void;
  className: string;
  testId: string;
};

export const Item = ({ item, handleOnClick, className, testId }: ItemProps) => {
  const isExternalLink = item.linkType === PageSwitcherTypes.External;

  const Link = isExternalLink ? ExternalLink : InternalLink;

  return (
    <Link
      {...{
        ...(isExternalLink ? { isExternal: true } : {}),
        ...(isExternalLink ? { href: item.path } : { to: item.path }),
        onClick: () => handleOnClick(item),
        textDecoration: 'none',
        className,
        'data-testid': testId,
      }}
    >
      <ItemWrapper>
        {item.icon || null}
        <div>
          <p className="item-title">{item.title}</p>
          {!item.description ? null : (
            <p className="item-description">{item.description}</p>
          )}
        </div>
      </ItemWrapper>
    </Link>
  );
};
